export default __webpack_public_path__ + "static/media/profile.90891dce.png";